<template>
	<div v-if="create" class="grow flex flex-col gap-4 items-center justify-center text-center text-gray-400">
		<LabeledObject full required>
			<template #label>{{ trans('general.empty') }}</template>
			<slot/>
		</LabeledObject>
	</div>
	<div v-else class="grow my-20 flex flex-col gap-4 md:gap-8 items-center justify-center text-center text-gray-400 overflow-y-auto">
		<i class="fa-solid fa-sad-cry text-[64px] md:text-[128px] lg:text-[192px]"/>
		<p class="text-3xl md:text-5xl font-thin">{{ trans('general.empty') }}</p>
	</div>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'
import {trans} from 'laravel-vue-i18n'
import LabeledObject from '@/Components/LabeledObject.vue'

defineProps<{
	create?:boolean,
}>()
</script>